import { render, staticRenderFns } from "./Loanable.vue?vue&type=template&id=2849d855&scoped=true&"
import script from "./Loanable.vue?vue&type=script&lang=js&"
export * from "./Loanable.vue?vue&type=script&lang=js&"
import style0 from "./Loanable.vue?vue&type=style&index=0&id=2849d855&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849d855",
  null
  
)

export default component.exports